
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS'
export const UPLOAD_PROGRESS_MESSAGE = 'UPLOAD_PROGRESS_MESSAGE'
export const UPLOAD_ERROR = 'UPLOAD_ERROR'
export const UPLOADED_FILES = 'UPLOADED_FILES'
export const SAVE_WORK = 'SAVE_WORK_EXPERIENCE'
